'use client';

import React from 'react';
import { SessionProvider } from 'next-auth/react';
import { Toaster } from 'sonner';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider data-component-id="src/components/Providers.tsx:9:4" data-component-path="src/components/Providers.tsx" data-component-line="9" data-component-end-line="23" data-component-file="Providers.tsx" data-component-name="SessionProvider" data-component-content="%7B%22elementName%22%3A%22SessionProvider%22%7D" refetchInterval={0} refetchOnWindowFocus={false}>
      {children}
      <Toaster data-component-id="src/components/Providers.tsx:11:6" data-component-path="src/components/Providers.tsx" data-component-line="11" data-component-end-line="22" data-component-file="Providers.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D"
        position="top-right"
        theme="light"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid rgba(11,14,40,0.15)',
            color: 'var(--primary-dark)',
            fontFamily: 'Roboto, sans-serif',
          },
        }}
      />
    </SessionProvider>
  );
}
